import React, { useEffect, useState } from "react";
import axios from "axios";
import Style from "../Style/FeaturedViewAdmin.module.scss";
const baseURL = process.env.REACT_APP_BASE_URL;

const FeaturedViewAdmin = () => {
  const [skills, setSkills] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({
    title: "",
    short_description: "",
    image: null,
  });

  useEffect(() => {
    fetchSkills();
  }, []);

  const fetchSkills = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/get/skills`);
      setSkills(res.data);
    } catch (err) {
      console.error("Error fetching skills:", err);
    }
  };

  const handleEditClick = (skill) => {
    setEditId(skill.id);
    setEditData({
      title: skill.title,
      short_description: skill.short_description,
      image: null,
    });
  };

  const handleEditChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "image") {
      setEditData({ ...editData, image: files[0] });
    } else {
      setEditData({ ...editData, [name]: value });
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", editData.title);
    formData.append("short_description", editData.short_description);
    if (editData.image) {
      formData.append("image", editData.image);
    }

    try {
      await axios.put(`${baseURL}/api/api/skills/${editId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      setEditId(null);
      fetchSkills();
    } catch (err) {
      console.error("Update failed:", err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseURL}/api/skills/delete/${id}`);
      setSkills(skills.filter((skill) => skill.id !== id));
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  return (
    <div className={Style.FeaturedViewAdmin}>
      <div className={Style.FeaturedAllSKill}>
        <h2>All Skills</h2>
      </div>

      {skills.length === 0 ? (
        <p>No skills found.</p>
      ) : (
        skills.map((skill) => (
          <div key={skill.id} className={Style.skillCard}>
            <img
              src={
                skill.image_url
                  ? skill.image_url
                  : "https://via.placeholder.com/60x40?text=No+Image"
              }
              alt={skill.title}
              className={Style.image}
            />

            {editId === skill.id ? (
              <form onSubmit={handleEditSubmit} className={Style.editForm}>
                <input
                  type="text"
                  name="title"
                  value={editData.title}
                  onChange={handleEditChange}
                  placeholder="Title"
                />
                <textarea
                  name="short_description"
                  value={editData.short_description}
                  onChange={handleEditChange}
                  placeholder="Short Description"
                ></textarea>
                <input type="file" name="image" onChange={handleEditChange} />
                <button type="submit">Save</button>
                <button type="button" onClick={() => setEditId(null)}>
                  Cancel
                </button>
              </form>
            ) : (
              <>
                <h3>{skill.title}</h3>
                <p>{skill.short_description}</p>
                <div className={Style.actions}>
                  <button onClick={() => handleEditClick(skill)}>Edit</button>
                  <button onClick={() => handleDelete(skill.id)}>Delete</button>
                </div>
              </>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default FeaturedViewAdmin;
